export default "__VITE_ASSET__Ca9B2w0v__"